import { EnvironmentState, UIData } from 'vrlcm-gui-types';
import { Http } from 'vrlcm-gui-utils';
import {
  ENVIRONMENT_URL,
  GET_ENVIRONMENT_STATE_URL,
  ORGANIC_GROWTH_URL,
  SCALE_OUT_URL
} from '../../constants/ApiUri';
import { getWorkflowSkeleton } from '../../mocks/specs';

export default class EnvironmentWorkflowAPI {
  public static getEnvironmentState = async (
    requestId: string
  ): Promise<EnvironmentState> => {
    try {
      const state = await Http.get(GET_ENVIRONMENT_STATE_URL(requestId));
      return state.data;
    } catch (error) {
      let workflowSkeleton = getWorkflowSkeleton();
      if (requestId === 'globalenvironment') {
        const uiData: UIData = {
          currentStep: 0,
          totalSteps: 2,
          stepStates: ['warning', undefined]
        };
        workflowSkeleton.requestId = requestId;
        workflowSkeleton.uiData = JSON.stringify(uiData);
      }
      return workflowSkeleton;
    }
  };

  public static patchCreateEnvironmentDetails = async (
    state: EnvironmentState
  ): Promise<void> => {
    const response = await Http.post(ENVIRONMENT_URL, state);
    return response.data;
  };

  public static patchScaleOutProductDetails = async (
    state: EnvironmentState
  ): Promise<void> => {
    const { environmentId, products } = state.environmentRequestDTO;
    const response = await Http.post(
      SCALE_OUT_URL(environmentId, products[0].id),
      state
    );
    return response.data;
  };

  public static patchOrganicGrowthDetails = async (
    state: EnvironmentState
  ): Promise<void> => {
    const { environmentId } = state.environmentRequestDTO;
    const response = await Http.post(ORGANIC_GROWTH_URL(environmentId), state);
    return response.data;
  };
}
